import { useRouteError } from 'react-router-dom';
import { useEffect } from 'react';
import { logger } from '@/utils/logger';
import { ErrorPage } from './ErrorPage';

/**
 * Error page that handles route errors using useRouteError.
 */
export default function RouteErrorPage(): JSX.Element {
    const error = useRouteError() as Error;

    useEffect(() => {
        logger.logIfError(error);
    }, [error]);

    return <ErrorPage message={error.message} />
};
